import React, { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { createAnnouncement, updateAnnouncement } from "../../utils/ApiCalls/Announcement";
import { checkFields } from "../../utils/Validation/checkFields";
import PropTypes from 'prop-types';

const AnnouncementInputs = ({ newsletter }) => {
  const [title, setTitle] = useState("");
  const [, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (newsletter) {
      setTitle(newsletter?.title);
      setIsActive(newsletter?.is_active === 1 );
    }
  }, [newsletter]);
  const handleCheckboxChange = () => {
    setIsActive(!isActive);
  };
  const addNewsLetter = async (e) => {
    e.preventDefault();
    let added = false;
    let dataValues = {
      title,
      is_active: isActive ? 1 : 0,
    };

    let valid = checkFields(dataValues);
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (newsletter?.id) {
        data = await updateAnnouncement(newsletter.id, values);
      } else {
        data = await createAnnouncement(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
      } else {
        added = true;
      }

      if (added && !newsletter.id) {
        navigate("/website/cms/homepage/announcement");
      } else {
        navigate("/website/cms/homepage/announcement");
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
      }
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addNewsLetter}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Title</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {newsletter.id ? "Update" : "Add"} Announcement
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};
AnnouncementInputs.propTypes = {
  newsletter: PropTypes.any,
};
export default AnnouncementInputs;
